









// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';
import EditDrawer from '@/components/shared/EditDrawer.vue'
import deepEqual from 'deep-equal'
import cloneDeep from 'clone-deep'
import { AloPersonne, getDefaultAloPersonne } from '@/models/alo/AloPersonne';

@Component({
  name: 'EditBasePersonne',    
  components:{EditDrawer},
  props: {
    title:String,            
    width:{
      type:String,
      default:"1200"
    },
    saveLabel:{
      type:String,
      default:"Sauvegarder"
    }
  } 
})
export default class EditBasePersonne extends Vue {
  
  private original = getDefaultAloPersonne()
  private modified = getDefaultAloPersonne()
  private showDrawer = false
  private saving = false 

  edit(item:AloPersonne) {        
    this.$store.myActions.ADM_PERSONNE_RESET_STATUS()
    this.showDrawer = true
    this.original = item
    this.modified = cloneDeep(item) 

    return this.modified   
  }  

  get isDirty() {
    return !deepEqual(this.original,this.modified)
  }

  get personneStatus() {
    return this.$store.myGetters.personneStatus        
  }

  saveData() {    
    if ((this.$refs.editForm as HTMLFormElement).validate()) {
      this.saving = true
      this.$store.myActions.ADM_PERSONNE_SAVE_REQUEST(this.modified).then(() => {
        this.$store.myActions.UI_ADD_SNACK_MESSAGE(this.personneStatus)          
        this.showDrawer = false
      }).finally(()=>{
        this.saving = false
      })    
    } 
  }

  
}
